import { useMemo } from "react";

export function useIsTouchDevice() {
  return useMemo(
    () => "ontouchstart" in window || navigator?.maxTouchPoints > 0,
    []
  );
}
